/** @format */

import {PeriodsModel} from 'components/PeriodSelector/model';

export const MAX_TEXT_LENGTH = 50;

export const SUB_ROWS_THRESHOLD = 100;

export const filterOrder: string[] = [
  'accountId',
  'campaignId',
  'adGroupId',
  'adId',
  'categoryDescription',
  'typeDescription',
];

export const TRANSLATION_KEY_PREFIX = 'ya_direct_changelog';

export const FIXED_HEIGHTS = {
  APP_HEADER: 60,
  BREADCRUMBS: 70,
  PERIOD_SELECTOR_FALLBACK: 80,
  FILTER_BAR_FALLBACK: 93,
  SCROLL_HEIGHT: 20,
  MIN_TABLE_HEIGHT: 200,
};

export const PERIODS: PeriodsModel[] = [
  {
    key: 'current',
    name: 'Текущий период',
  },
  {
    key: 'quarter',
    name: '3 месяца',
  },
  {
    key: 'month',
    name: 'Месяц',
  },
  {
    key: 'week',
    name: 'Неделя',
  },
];
